<section class="mb-5 " data-aos="fade-left" data-aos-duration="1000" >
<div id="productCarousel" class="carousel slide carousel-fade" data-ride="carousel" >
    <ol class="carousel-indicators">
      <li data-target="#productCarousel" data-slide-to="0" class="active"></li>
      <li data-target="#productCarousel" data-slide-to="1"></li>
      <li data-target="#productCarousel" data-slide-to="2"></li>
    </ol>
    <div class="carousel-inner" role="listbox" >
      <div class="carousel-item active" data-interval="1500">
        <div class="view">
          <img class=" rounded img-fluid" src="../../../assets/images/product/header/header1.jpg"
            alt="First slide">
          <div class="mask rgba-black-light"></div>
        </div>
        <div class="carousel-caption">
          <h3 class="h3-responsive">Best Case Quality</h3>
          <p>High Quality with elegant Case</p>
        </div>
      </div>
      <div class="carousel-item" data-interval="1500">
        <div class="view">
          <img class=" rounded  img-fluid" src="../../../assets/images/product/header/header2.jpg"
            alt="Second slide">
          <div class="mask rgba-black-strong"></div>
        </div>
        <div class="carousel-caption">
          <h3 class="h3-responsive">Strong Case</h3>
          <p>Case can protect your phone</p>
        </div>
      </div>
      <div class="carousel-item" data-interval="1500">
        <div class="view">
          <img class=" rounded " src="../../../assets/images/product/header/header3.jpg"
            alt="Third slide">
          <div class="mask rgba-black-slight"></div>
        </div>
        <div class="carousel-caption text-dark">
          <h3 class="h3-responsive">Big Promo</h3>
          <p>We have Big Deal with 50% Discount</p>
        </div>
      </div>
    </div>
    <a class="carousel-control-prev" href="#productCarousel" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#productCarousel" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</section>



